import React, { useState, useContext, useCallback } from 'react';
import { UserContext } from '../../../contexts/userProvider';
import { SecretariasContext } from '../../../contexts/secretariasProvider';
import { ClientContext } from '../../../contexts/clientProvider';
import LoadingSpinner from '../../Loader/load';
import BaseInput from '../../General/FormsComp/Input/BaseInput';
import BaseSelect from '../../General/FormsComp/Select/BaseSelect';
import BaseButton from '../../General/FormsComp/Button/BaseButton';

const formatCNPJ = (value) => {
  const cleaned = value.replace(/\D/g, '');
  return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};



const Cadastro = ({ onTabChange }) => {
  const { user, setAlert } = useContext(UserContext);
  const { createSecretaria } = useContext(SecretariasContext);
  const { clientes } = useContext(ClientContext);
  const [newSecretaria, setNewSecretaria] = useState({
    nome: '',
    cnpj: '',
    email: '',
    id_cliente: ''
  });
  const [loading, setLoading] = useState(false);

  // Manipula mudanças nos inputs
  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;

    let formattedValue = value;

    // Formatação automática para campos específicos
    if (name === 'cnpj') {
      formattedValue = formatCNPJ(value);
    }

    setNewSecretaria((prevData) => ({ ...prevData, [name]: formattedValue }));
  }, []);

  // Validação e salvamento da secretaria
  const handleSave = useCallback(async () => {
    // Validações básicas
    if (!newSecretaria.nome) {
      setAlert({
        visible: true,
        title: "Atenção!",
        placeholder: "Nome é obrigatório",
        confirm: false,
        type: "warning",
      });
      return;
    }

    if (!newSecretaria.id_cliente) {
      setAlert({
        visible: true,
        title: "Atenção!",
        placeholder: "Cliente é obrigatório",
        confirm: false,
        type: "warning",
      });
      return;
    }

    setLoading(true);
    try {
      const result = await createSecretaria({
        ...newSecretaria,
        criado_por: user.id,
        data_criacao: new Date().toISOString()
      });

      if (result) {
        // Limpar formulário
        setNewSecretaria({
          nome: '',
          cnpj: '',
          email: '',
          id_cliente: ''
        });

        // Voltar para aba de consulta
        onTabChange('consulta');
      }
    } catch (error) {
      console.error('Erro ao salvar secretaria:', error);
    } finally {
      setLoading(false);
    }
  }, [newSecretaria, setAlert, user, createSecretaria, onTabChange]);

  return (
    <div className='secretaria-cadastro-container'>
      {loading && <LoadingSpinner />}

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-vox-xl p-6 mb-6">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-6">
          Cadastrar Nova Secretaria
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <BaseSelect
            label="Cliente"
            name="id_cliente"
            value={newSecretaria.id_cliente}
            onChange={handleInputChange}
            options={clientes || []}
            placeholder="Selecione um cliente"
            valueKey="id"
            labelKey="nome"
            required
          />
          <BaseInput
            label="Nome da Secretaria"
            name="nome"
            value={newSecretaria.nome}
            onChange={handleInputChange}
            placeholder="Digite o nome da secretaria"
            required
          />

          <BaseInput
            label="CNPJ"
            name="cnpj"
            value={newSecretaria.cnpj}
            onChange={handleInputChange}
            placeholder="00.000.000/0000-00"
            required
          />

          <BaseInput
            label="Email"
            name="email"
            type="email"
            value={newSecretaria.email}
            onChange={handleInputChange}
            placeholder="secretaria@exemplo.gov.br"
            required
          />

        </div>
      </div>

      <div className='flex justify-center mt-6'>
        <BaseButton
          onClick={handleSave}
          disabled={loading}
          variant="primary"
          size="lg"
        >
          {loading ? 'Salvando...' : 'Salvar Secretaria'}
        </BaseButton>
      </div>
    </div>
  );
};

export default Cadastro;
